import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import { accountsService } from 'src/services/accounts.service'
import { IFilter } from 'src/components/filter/types/filter.types'

import { QUERY_KEYS } from 'src/constants'
import { removeDefaultParams } from 'src/common/utils'

const initialAccountUsersFilterValues = {
  query: '',
}

const useAccountUsers = (filter?: IFilter, accountIdExt?: string) => {
  const { accountId } = useParams()

  const id = accountIdExt || accountId
  return useQuery([QUERY_KEYS.ACCOUNT_USERS, id, filter], () => {
    if (!id) return null

    return accountsService.getAccountUsers(
      removeDefaultParams({ ...filter, account: id }, initialAccountUsersFilterValues),
      id,
    )
  })
}

export { useAccountUsers }
